import { Icon } from "@/components/ui/Icon";

// A small floating "remove" X badge for staged attachment thumbnails/chips.
// Render inside a `position: relative` wrapper — it pins to the top-right corner.
//
// Dark-mode rule (the recurring footgun): BOTH grounds are theme tokens that flip
// together (`--ink-1` background ↔ `--surface` foreground), so the X stays legible
// in light AND dark. Never reintroduce a hardcoded `#fff` foreground here — on the
// flipping `--ink-1` background it disappears in dark mode (white-on-near-white).
export function RemoveBadge({
  onClick,
  label,
  size = 18,
}: {
  onClick: () => void;
  label: string;
  size?: number;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      title={label}
      aria-label={label}
      style={{
        position: "absolute",
        top: -6,
        right: -6,
        width: size,
        height: size,
        borderRadius: 999,
        border: "none",
        background: "var(--ink-1)",
        color: "var(--surface)",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 0,
      }}
    >
      <Icon name="x" size={Math.round(size * 0.6)} />
    </button>
  );
}
